// Componente de logotipo — exibe a imagem do brasão da cidade
// Aceita prop "size" para alternar entre tamanho normal e grande
function Logo({ size = "normal" }) {
  // Define a altura da imagem com base na prop size
  const h = size === "large" ? 80 : 48;
  return (
    <img
      src="/logotipo.png"
      alt="São Gonçalo do Rio Abaixo"
      style={{ height: h, objectFit: "contain" }}
    />
  );
}

export default Logo;
